import { NgModule } from '@angular/core';
import { LayoutModule } from 'src/app/layout/layout.module';
import { UniversalModule } from 'src/app/universal';
import { ClosingChecksRoutingModule, routedComponents } from './closing-checks-routing.module';
import { PageModule } from 'platform-ui/page';
import { CardModule } from 'platform-ui/card';
import { StackModule } from 'platform-ui/stack';
import { FormsModule } from '@angular/forms';
import { FormFieldModule } from 'platform-ui/form-field';
import { ItemListModule } from 'platform-ui/item-list';

@NgModule({
    declarations: [...routedComponents],
    imports: [UniversalModule, 
        LayoutModule,
        PageModule,
        CardModule,
        StackModule,
        FormFieldModule,
        ItemListModule,
        ClosingChecksRoutingModule],
})
export class ClosingChecksModule {}
